import api from "./api";
async function getMessageTemplates() {
  try {
    const response = await api.get("api/messageTemplates");
    return response.data;
  } catch (error) {
    return [];
  }
}

async function createMessageTemplate(
  name,
  emailBody,
  emailSubject,
  smsMessage,
  sendAsPlainText) {
  try {
    const response = await api.post(
      "api/messageTemplates",
      {
        name,
        emailBody,
        emailSubject,
        smsMessage,
        sendAsPlainText
      }
    );
    return response.data;
  } catch (error) {
    return [];
  }
}

async function updateMessageTemplate(
  id,
  name,
  emailBody,
  emailSubject,
  smsMessage,
  sendAsPlainText) {
  try {
    const response = await api.put(
      `api/messageTemplates/${id}`,
      {
        name,
        emailBody,
        emailSubject,
        smsMessage,
        sendAsPlainText
      }
    );
    return response.data;
  } catch (error) {
    return [];
  }
}

async function deleteMessageTemplate(id) {
  try {
    const response = await api.delete(`api/messageTemplates/${id}`);
    return response.data;
  } catch (error) {
    return [];
  }
}

export {
  getMessageTemplates,
  createMessageTemplate,
  updateMessageTemplate,
  deleteMessageTemplate
};